import {
  DirectionsBoatIcon,
  ListItemIcon,
  ListItemLink,
  ListItemText,
  MessageIcon,
  Theme,
  Typography,
  useTheme,
} from '@freighthub/silhouette-core'
import { cloneElement, FC, ReactElement, ReactNode } from 'react'

import { SearchCategory } from './Search'

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
const categoryIconMap: Record<SearchCategory, ReactElement<any>> = {
  [SearchCategory.Shipments]: <DirectionsBoatIcon />,
  [SearchCategory.Messages]: <MessageIcon />,
}

const getStyles = (theme: Theme) => ({
  root: {
    height: theme.spacing(7),
    padding: theme.spacing(0, 2),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  iconWrapper: {
    minWidth: 0,
    margin: 0,
    color: theme.palette.text.secondary,
  },
  icon: {
    height: 24,
    width: 24,
  },
  text: {
    marginLeft: theme.spacing(2),
    padding: 0,
    overflow: 'hidden',
  },
  primaryTypography: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  secondaryTypography: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
})

export interface TopBarSearchItemData {
  category: SearchCategory
  primaryText: ReactNode
  secondaryText: ReactNode
  path: string
}

interface TopBarSearchItemProps {
  data: TopBarSearchItemData
  onClick: () => void
}

export const TopBarSearchItem: FC<TopBarSearchItemProps> = ({ data, onClick }) => {
  const styles = getStyles(useTheme())
  const theme = useTheme()
  const { category, primaryText, secondaryText, path } = data

  return (
    <ListItemLink to={path} onClick={onClick} sx={styles.root}>
      <ListItemIcon sx={styles.iconWrapper}>
        {cloneElement(categoryIconMap[category], { sx: styles.icon })}
      </ListItemIcon>
      <ListItemText
        sx={styles.text}
        primary={
          <Typography variant="body2" color={theme.palette.text.secondary} sx={styles.primaryTypography}>
            {primaryText}
          </Typography>
        }
        secondary={
          <Typography variant="body3" color={theme.palette.text.secondary} sx={styles.secondaryTypography}>
            {secondaryText}
          </Typography>
        }
      />
    </ListItemLink>
  )
}
